import 'responsive-tabs';

(function ($) {
    $(function () {
        var $responsiveTabs = $('.site-homepage__book-feeds, .js-responsive-tabs');
        //homepage
        $responsiveTabs.responsiveTabs({
            setHash: false,
            scrollToAccordion: true,
            scrollToAccordionOnLoad: false,
            accordionTabElement: '<h2></h2>',
            duration: 300,
            collapsible: true,
            active: 0,
            activate: function (event, tab) {
                if ($(tab.selector).find('.slick-slider').length) {
                    $(tab.selector).find('.slick-slider').slick('setPosition');
                    setTimeout(function () {
                        $(window).trigger('resize');
                    });
                }
                if ($(tab.selector).find('.isbn-grid').length) {
                    $(window).trigger('resize');
                }
            }
        });

        $responsiveTabs.find('.slick-track').attr('title', 'slick carousel');
    });
})(jQuery);
